"use client";

import { useEffect, useState } from "react";
import { cn } from "@/lib/shared/utils";

function getRemaining(target: string) {
  const seconds = Math.max(0, Math.floor((new Date(target).getTime() - Date.now()) / 1000));
  return {
    days: Math.floor(seconds / 86400),
    hours: Math.floor((seconds % 86400) / 3600),
    minutes: Math.floor((seconds % 3600) / 60),
    seconds: seconds % 60,
  };
}

export default function DropCountdown({
  target,
  ended = false,
  className,
}: {
  target: string;
  ended?: boolean;
  className?: string;
}) {
  const [remaining, setRemaining] = useState(() => getRemaining(target));
  const complete = ended || Object.values(remaining).every((value) => value === 0);

  useEffect(() => {
    if (ended) return;
    const timer = window.setInterval(() => setRemaining(getRemaining(target)), 1000);
    return () => window.clearInterval(timer);
  }, [ended, target]);

  if (complete) return null;

  return (
    <span
      className={cn("font-mono text-[10px] tracking-[0.18em] uppercase", className)}
      aria-label="Time remaining"
    >
      {remaining.days}d {String(remaining.hours).padStart(2, "0")}h{" "}
      {String(remaining.minutes).padStart(2, "0")}m
    </span>
  );
}
